import React, { useEffect, useState } from "react";
import { ControlData } from "../../../../../model/manifest/ControlData";
import { ComboBox, IComboBox, IComboBoxOption, TooltipHost } from "@fluentui/react";
import { ConnectForm } from "../../../form/ConnectForm";
import { Controller } from "react-hook-form";
import { useRecoilValue } from "recoil";
import { applicationManifestState, globalBusinessRulesState } from "../../../../../recoil/atoms";
import { ApplicationManifest } from "../../../../../model/manifest/ApplicationManifest";
import { getRules } from "../../../../../services/ruleService";
import { BusinessRule } from "../../../../../model/manifest/BusinessRule";
import { useId } from "@fluentui/react-hooks";
import { buildFormPropertyName, getFormattedOptions, readOnlyTextForDataSource } from "../../../../../services/fieldService";
import axios from "axios";
import { DataSourceItem } from "../../../../../model/manifest/DataSourceItem";
import { ViewDropdownRecord } from "../helpers/ViewDropdownRecord";
import { ReadOnlyDropdownField } from "../../ReadOnlyDropdownField";
import { ISubFormField } from "../../../../../interfaces/ISubFormField";
import { cloneDeep } from "lodash";
import { getDataSourceItems } from "../../../../../services/dataSourceService";

export interface TypeAheadFieldProps {
    control: ControlData;
    shouldValidate: boolean;
    disabled: boolean;
    readOnly: boolean;
    isRequired: boolean;
    isSearch: boolean;
    entityId: string | undefined;
    subFormField: ISubFormField | undefined;
}

export const TypeAheadField: React.FC<TypeAheadFieldProps> = (props: TypeAheadFieldProps) => {
    const applicationManifest: ApplicationManifest = useRecoilValue(applicationManifestState);
    const globalBusinessRules: BusinessRule[] = useRecoilValue(globalBusinessRulesState);
    const [dataSourceItems, setDataSourceItems] = useState<DataSourceItem[]>();
    const CancelToken = axios.CancelToken;
    const source = CancelToken.source();
    const dropdownId = useId("dropdown");
    const tooltipId = useId("tooltip");
    const calloutProps = {
        gapSpace: 0,
        target: `#${dropdownId}`
    };

    useEffect(() => {
        getDataSourceItems(applicationManifest.Id!, props.control.PageId, props.control.Id!, props.isSearch, source.token)
            .then((result) => {
                setDataSourceItems(result);
            })
            .catch((error) => {

            });
        return function cleanup() {
            source.cancel();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <ConnectForm>
            {(methods: any) =>
                <Controller
                    control={methods.control}
                    rules={getRules(applicationManifest, props.control, globalBusinessRules, props.shouldValidate, props.entityId == null)}
                    name={buildFormPropertyName(props.control.Id!, false, undefined, props.subFormField)}
                    render={({ field: { onChange, value } }) => (
                        <>
                            {!props.readOnly &&
                                <TooltipHost
                                    content={props.control.ToolTipText}
                                    id={tooltipId}
                                    calloutProps={calloutProps}
                                >
                                    <ViewDropdownRecord
                                        control={props.control}
                                        value={value}
                                        dropdownId={dropdownId}
                                        isRequired={props.isRequired}
                                    />
                                    <ComboBox
                                        id={dropdownId}
                                        selectedKey={dataSourceItems != null ? value : ""}
                                        disabled={props.disabled}
                                        options={getFormattedOptions(dataSourceItems,
                                            applicationManifest.DataSources.find(i => i.Name === props.control.DataSourceName)!,
                                            props.control.DefaultSearchTextValue,
                                            props.entityId,
                                            props.isSearch,
                                            true)}
                                        allowFreeform={false}
                                        autoComplete={"on"}
                                        errorMessage={
                                            methods.formState.errors != null &&
                                                methods.formState.errors[props.control.Id!] != null &&
                                                methods.formState.errors[props.control.Id!].message != null ?
                                                methods.formState.errors[props.control.Id!].message :
                                                undefined}
                                        onChange={(event: React.FormEvent<IComboBox>, option?: IComboBoxOption, index?: number, value?: string) => {
                                            var myValue = option != null && option.key != null ? option.key : "";
                                            //React Hook Form requires you call the array Update method when editing an array as well as the onChange method.
                                            if (props.subFormField != null) {
                                                var myCurrentValue = methods.getValues(props.subFormField.ParentControlId)[props.subFormField.Index];
                                                var updateableField = cloneDeep(myCurrentValue);
                                                updateableField[props.control.Id!] = myValue;
                                                props.subFormField.update(props.subFormField.Index, updateableField);
                                            }
                                            onChange(myValue);
                                        }} />
                                </TooltipHost>
                            }
                            {props.readOnly &&
                                <ReadOnlyDropdownField
                                    control={props.control}
                                    textValue={readOnlyTextForDataSource(
                                        value, 
                                        dataSourceItems
                                    )}
                                    value={value}
                                />
                            }
                        </>
                    )} />
            }
        </ConnectForm>
    );
}